angular.module('satv.search', [
    'ngResource',
    'satv.loader',
    'angular-growl'
])

.constant('config',  app_config)
.filter('plusOrMinus', function(){
    return function(input){
        var parsedInput = input ? parseInt(input) : 0;
        if (isNaN(parsedInput)) {
            if (input.charAt(0) === '-') {
                return false;
            } else {
                return true;
            }
        }
        return parsedInput > 0 ? true : false;
    };
})
;



// WEBPACK FOOTER //
// ./vendor/sonyatv/searchclientbundle/Resources/js/angular/module.js